import React from 'react';
import '@porterin/feature/src/ui/styles/global/main.scss';
import '@porterin/feature/src/ui/styles/global/muiStyle.scss';
import AppContainer from '@porterin/feature/src/containers/app/App.mjs';

export default function App(props) {
  return <AppContainer {...props} />;
}
